import { RefObject, useEffect, useRef } from "react";
import { off, on } from "react-use/lib/misc/util";

const defaultEvents = ["mousedown", "touchstart"];

const useClickAwayMulti = <E extends Event = Event>(
	refs: RefObject<HTMLElement | null> | Array<RefObject<HTMLElement | null>>,
	onClickAway: (event: E) => void,
	events: string[] = defaultEvents
) => {
	const savedCallback = useRef(onClickAway);
	useEffect(() => {
		savedCallback.current = onClickAway;
	}, [onClickAway]);

	useEffect(() => {
		const handler = (event: any) => {
			// const { current: el } = refs;
			const els: Array<HTMLElement> = [];
			if (!Array.isArray(refs)) refs.current && els.push(refs.current);
			else refs.forEach((ref) => ref.current && els.push(ref.current));

			let shouldCall = true;
			els.forEach((el) => {
				el.contains(event.target) && (shouldCall = false);
			});
			shouldCall && savedCallback.current(event);
		};
		for (const eventName of events) {
			on(document, eventName, handler);
		}
		return () => {
			for (const eventName of events) {
				off(document, eventName, handler);
			}
		};
	}, [events, refs]);
};

export default useClickAwayMulti;
